import { object, string } from "yup";

export const LoginFormValidation = object().shape({
    email: string().email().required('Email is required'),
    password: string().required('Password is required'),
});
export const RegisterFormValidation = object().shape({
    email: string().email().required('Email is required'),
    password: string().required('Password is required'),
    phone: string().required("Valid contact number is required")
});
export const ResetFormValidation = object().shape({
    email: string().email().required('Email is required'),
});

export const LoginFormInitialValues = {
    email: '',
    password: '',
};
export const ResetFormInitialValues = {
    email: '',
};